import { useEffect, useRef } from "react";
import type { K8sdiagFocus } from "@k8s-dashboard/contracts";
import { deleteViewer, putViewer } from "@/api/diagnose";

/**
 * 공유가 켜져 있는 동안 지금 보고 있는 화면을 상류에 등록해 둡니다. (ADR-0005 §1)
 *
 * 같은 좌표를 다시 보내지 않습니다 — 쿼리만 바뀌는 자동 갱신마다 등록을 쏘면
 * 라우트 하나가 요청 수십 개가 됩니다. 끄면 정확히 한 번 지우고, 화면을 떠날
 * 때도 지웁니다. 실패는 조용히 무시합니다: 좌표가 없으면 서비스가 되물을 뿐이고,
 * 화면 이동이 진단 오류로 멈출 이유가 없습니다.
 */
export function useViewerShare(share: boolean, focus: K8sdiagFocus | null): void {
  const reported = useRef("");

  useEffect(() => {
    const next = share && focus ? JSON.stringify(focus) : "";
    if (next === reported.current) return;
    reported.current = next;
    if (next && focus) void putViewer(focus);
    else void deleteViewer();
  }, [share, focus]);

  useEffect(
    () => () => {
      if (reported.current) void deleteViewer();
    },
    [],
  );
}
